import React from 'react'
import { IntlProvider } from 'react-intl'
import { LogoCenter } from '../shared/logo'
import { i18n } from '../config/i18n'
import translations from '../translations'

const Loading: React.FC = () => {
  const language = i18n.detectBrowserLanguage()
  const messages = Object.assign({}, translations[language])

  return (
    <IntlProvider locale={language} messages={messages}>
      <div className=" flex h-screen flex-col justify-center">
        <LogoCenter />
      </div>
    </IntlProvider>
  )
}

export { Loading }
